import { css } from 'linaria';
import { media } from '../../../../../media';

export const SmallBtn = css`
	${media.mobile} {
		padding: 4px 12px !important;
		border: none;

		& * {
			font-weight: 400 !important;
		}
	}
`;

export const Btn = css`
	max-height: 40px;
`;
